import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";

interface ContentAdminProps {
  didClickOption: () => void;
}

export const ContentAdmin = (props: ContentAdminProps) => {
  const {
    templateListAdmin,
    collectionsAdmin,
    home,
    checkout,

    projectList,
    navigateTo,
  } = usePaths();

  return (
    <div className={styles.adminContent}>
      <span className={styles.sectionTitle}>ADMIN</span>
      <MenuOption
        label="Home"
        icon="HOME"
        onClick={() => {
          navigateTo(home);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Projects"
        icon="FOLDER"
        onClick={() => {
          navigateTo(projectList);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Templates"
        icon="TEMPLATES"
        onClick={() => {
          navigateTo(templateListAdmin);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Collections"
        icon="COLLECTIONS"
        onClick={() => {
          navigateTo(collectionsAdmin);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Checkout"
        icon="BAG"
        onClick={() => {
          navigateTo(checkout);
          props.didClickOption();
        }}
      />
    </div>
  );
};
